import { render, staticRenderFns } from "./EmptyTableMessageComponent.vue?vue&type=template&id=36c5f488&"
import script from "./EmptyTableMessageComponent.vue?vue&type=script&lang=ts&"
export * from "./EmptyTableMessageComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36c5f488')) {
      api.createRecord('36c5f488', component.options)
    } else {
      api.reload('36c5f488', component.options)
    }
    module.hot.accept("./EmptyTableMessageComponent.vue?vue&type=template&id=36c5f488&", function () {
      api.rerender('36c5f488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/EmptyTableMessageComponent.vue"
export default component.exports